// 部门
import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { materialQuery } from '@/api/demo/demo/types';
/**
 * 下拉树列表
 * @param query
 * @returns {*}
 */
export const categoryTreeListApi = (query?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/categoryTreeList',
    method: 'get',
    params: query,
  });
};
/**
 *新增素材分类
 * @param query
 * @returns {*}
 */
export const addCategoryApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/addCategory',
    method: 'post',
    data,
  });
};
/**
 *编辑素材分类
 * @param query
 * @returns {*}
 */
export const editCategoryApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/editCategory',
    method: 'post',
    data,
  });
};
/**
 *删除素材分类
 * @param query
 * @returns {*}
 */
export const removeCategoryApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/removeCategory',
    method: 'post',
    params: data,
  });
};

/**
 *分页查询素材列表
 * @param query
 * @returns {*}
 */
export const materialListApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/list',
    method: 'get',
    params: data,
  });
};
/**
 *编辑素材
 * @param query
 * @returns {*}
 */
export const editMaterialApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/editMaterial',
    method: 'post',
    data,
  });
};
/**
 *删除素材
 * @param query
 * @returns {*}
 */
export const removeMaterialApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/removeMaterial',
    method: 'post',
    data,
  });
};
/**
 *移动素材
 * @param query
 * @returns {*}
 */
export const moveMaterialApi = (data?: materialQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/material/moveMaterial',
    method: 'post',
    data,
  });
};
/**
 *移动素材
 * @param query
 * @returns {*}
 */
export const addMaterialApi = (params?: materialQuery): AxiosPromise<[]> => {
  const formData = new FormData();
  // 后端接收的文件字段名：files
  formData.append('files', params.file);
  return request({
    url: '/b/brand/material/addMaterial',
    method: 'post',
    params: {
      type: params.type,
      categoryId: params.categoryId,
    },
    data: formData, // FormData 放在 data 里
    headers: {
      'Content-Type': 'multipart/form-data', // 覆盖默认的 json 头
    },
  });
};
